import axiosInstance from '../services/AxiosInstance';

export function getProperties(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`property?pageNum=${pageNum}&pageSize=${pageSize}&${filterQuery}&orderBy=createdAt`);
}

export function getReportProperties( filterQuery = "") {
    return axiosInstance.get(`property?noPagination=true&populate=propertyTypeId&${filterQuery}`);
}

export function getProperty(id, populate) {
    return axiosInstance.get(`property/${id}?populate=${populate}`);
}

export function deleteProperty(id) {
    return axiosInstance.delete(`property/${id}`);
}

export function createProperty(data) {
    return axiosInstance.post(`property`,data);
}

export function updateProperty(id, data) {
    return axiosInstance.put(`property/${id}`,data);
}

export function getPropertyFilters() {
    return axiosInstance.get(`all-filters`);
}

export function getReportedAds(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery) {
    return axiosInstance.get(`ad-report?pageNum=${pageNum}&pageSize=${pageSize}&${filterQuery}&orderBy=createdAt`);
}
